export enum EPriceType {
  SM = 1,
  Total = 2,
}
